module.exports = function anonymous(it
/**/) {
var out='<div class="dropdown menu-ctrl"> <!-- <button class="btn"><i class="fui-settings-16"></i></button> --> <button class="btn">&#9660;</button> <ul class="dropdown-menu" role="menu"> <li><a tabindex="-1" href="#" class="export-csv-ctrl">Export as CSV</a></li> <li><a tabindex="-1" href="#" class="log-plot-ctrl">Toggle Log Plot</a></li> <!-- <li><a tabindex="-1" href="#">Another action</a></li> <li><a tabindex="-1" href="#">Something else here</a></li> <li class="divider"></li> <li><a tabindex="-1" href="#">Separated link</a></li> --> </ul></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dot-loader!./browser/library/js/templates/plot-menu.tpl
 ** module id = 485
 ** module chunks = 1
 **/